import React from 'react';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import { InputStyle } from '.';

const Container = styled.label<{ displayOutline?: boolean }>`
  ${tw`relative`}

  &:focus-within {
    z-index: 1;
  }

  ${({ displayOutline }) =>
    displayOutline &&
    css`
      z-index: 1;
    `}
`;

type TIconTextFieldRounded = 'FULL' | 'TOP' | 'BOTTOM';

interface FieldProps {
  rounded: TIconTextFieldRounded;
  as?: 'button' | 'input';
  isFilled?: boolean;
  displayOutline?: boolean;
}

const Field = styled.input<FieldProps>`
  ${InputStyle}
  ${tw`w-full px-medium rounded-none placeholder-white`}
  padding-left:48px;
  text-align: start !important;
  ${({ as, isFilled }) => as === 'button' && !isFilled && tw`text-placeHolders`}

  ${({ rounded }) => {
    if (rounded === 'FULL') {
      return tw`rounded-30`;
    } else if (rounded === 'TOP') {
      return tw`rounded-tl-30 rounded-tr-30`;
    } else if (rounded === 'BOTTOM') {
      return css`
        ${tw`rounded-bl-30 rounded-br-30`}
      `;
    }
  }}
`;

const IconWrapper = styled.div<{ isRight?: boolean }>`
  ${tw`absolute flex justify-center items-center`}
  top:50%;
  transform: translateY(-50%);
  ${({ isRight }) => (isRight ? 'right' : 'left')}: 16px;
`;

interface IconTextFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  rounded: TIconTextFieldRounded;
  isFilled?: boolean;
  as?: 'button' | 'input';
  leftIcon: JSX.Element;
  rightIcon?: JSX.Element;
  inputRef?: React.MutableRefObject<HTMLInputElement>;
  displayOutline?: boolean;
}

const IconTextField: React.FC<IconTextFieldProps> = (props) => (
  <Container displayOutline={props.displayOutline}>
    <IconWrapper>{props.leftIcon}</IconWrapper>
    <Field {...props} ref={props.inputRef} />

    {props.rightIcon && <IconWrapper isRight>{props.rightIcon}</IconWrapper>}
  </Container>
);

export default IconTextField;
